(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["enm-step1-configurator"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // ── State ────────────────────────────────────────────────
    var state = {
      productId: null,
      productTitle: '',
      collection: '',
    };

    var COLLECTION_LABELS = {
      'custom-rectangular-nameplates': 'Rectangular Nameplates',
      'unique-shape-nameplates': 'Shaped & Decorative',
      'memorial-recognition-nameplates': 'Memorial & Recognition',
      'name-badges': 'Name Badges',
      'industrial-tags': 'Industrial Tags',
    };

    // ── Accordion toggle ─────────────────────────────────────
    // One accordion open at a time; clicking the active header closes it.
    document.querySelectorAll('.enm-s1__acc-header').forEach(function (hdr) {
      hdr.addEventListener('click', function () {
        var item = hdr.closest('.enm-s1__acc-item');
        var isActive = item.classList.contains('enm-s1__acc-item--active');

        document.querySelectorAll('.enm-s1__acc-item').forEach(function (i) {
          i.classList.remove('enm-s1__acc-item--active');
          i.classList.add('enm-s1__acc-item--inactive');
        });

        if (!isActive) {
          item.classList.add('enm-s1__acc-item--active');
          item.classList.remove('enm-s1__acc-item--inactive');
        }
      });
    });

    // ── Product card selection ────────────────────────────────
    document.querySelectorAll('.enm-s1__card').forEach(function (card) {
      card.addEventListener('click', function () {
        // Deselect all cards across all accordions
        document.querySelectorAll('.enm-s1__card').forEach(function (c) {
          c.classList.remove('enm-s1__card--selected');
        });

        card.classList.add('enm-s1__card--selected');

        state.productId = card.getAttribute('data-product-id');
        state.productHandle = card.getAttribute('data-product-handle') || '';
        state.productTitle = card.getAttribute('data-product-title');
        state.collection = card.getAttribute('data-collection');
        state.priceMin = card.getAttribute('data-price-min') || '';
        state.plateShape = card.getAttribute('data-plate-shape') || '';

        // Persist selection so it survives navigation to frontpage and back
        try {
          sessionStorage.setItem('_enm_s1_product_handle', state.productHandle);
        } catch (e) {}

        // If the collection changed, clear canvas state so collection-specific layers
        // (barcode, QR code, shaped-plate SVG, border PNG, etc.) don't bleed into
        // a new product type. Same collection → layers carry over unchanged.
        try {
          var _cs = JSON.parse(sessionStorage.getItem('_canvas_state') || '{}');
          if (_cs.collection && _cs.collection !== state.collection) {
            sessionStorage.removeItem('_canvas_state');
          }
        } catch (e) {}

        // If the customer arrived from an edit session and picks a different product,
        // exit edit mode so Step 3 adds a new cart item instead of replacing the original.
        // Set _enm_product_changed so Step 3 can show a contextual notice.
        try {
          if (sessionStorage.getItem('_enm_edit_line_item_key')) {
            var _cs2 = JSON.parse(sessionStorage.getItem('_canvas_state') || '{}');
            if (state.productHandle !== (_cs2.productHandle || '')) {
              sessionStorage.removeItem('_enm_edit_line_item_key');
              sessionStorage.setItem('_enm_product_changed', '1');
            }
          }
        } catch (e) {}
        state.plateHeight = parseFloat(card.getAttribute('data-plate-height')) || null;
        state.plateWidth = parseFloat(card.getAttribute('data-plate-width')) || null;
        state.plateShapeSvg = card.getAttribute('data-plate-shape-svg') || '';
        state.plateSvgVw = parseFloat(card.getAttribute('data-plate-svg-vw')) || null;
        state.plateSvgVh = parseFloat(card.getAttribute('data-plate-svg-vh')) || null;
        state.borderPng = card.getAttribute('data-border-png') || '';
        state.borderMargin = parseFloat(card.getAttribute('data-border-margin')) || 0;

        updateUI();
      });
    });

    // ── "Change selection" clears state ──────────────────────
    var changeBtn = document.getElementById('enm-sel-change');
    if (changeBtn) {
      changeBtn.addEventListener('click', function () {
        document.querySelectorAll('.enm-s1__card').forEach(function (c) {
          c.classList.remove('enm-s1__card--selected');
        });
        state.productId = null;
        try {
          sessionStorage.removeItem('_enm_s1_product_handle');
        } catch (e) {}
        updateUI();
      });
    }

    // ── CTA — desktop ────────────────────────────────────────
    var nextBtn = document.getElementById('enm-next-btn');
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (state.productId) window.location.href = buildNextUrl();
      });
    }

    // ── CTA — mobile ─────────────────────────────────────────
    var mobileNextBtn = document.getElementById('enm-mobile-next-btn');
    if (mobileNextBtn) {
      mobileNextBtn.addEventListener('click', function () {
        if (state.productId) window.location.href = buildNextUrl();
      });
    }

    // ── Helpers ───────────────────────────────────────────────
    function buildNextUrl() {
      // Real products → product page template (product.design-studio.json).
      // Liquid injects all product data server-side; only pass the collection
      // so Step 2 knows the product type when collections haven't been resolved.
      // Dev placeholders (handle starts with "dev-") still use the legacy page route.
      var handle = state.productHandle || '';
      if (handle && handle.indexOf('dev-') !== 0) {
        var p = { collection: state.collection };
        return '/products/' + handle + '?' + new URLSearchParams(p).toString();
      }

      // Legacy / dev fallback: pass everything via URL params
      var p = {
        product_handle: handle,
        collection: state.collection,
        product_name: state.productTitle || '',
        plate_shape: state.plateShape || '',
      };
      if (state.plateHeight) p.plate_height = state.plateHeight;
      if (state.plateWidth) p.plate_width = state.plateWidth;
      if (state.plateShapeSvg) p.plate_shape_svg = state.plateShapeSvg;
      if (state.plateSvgVw) p.plate_svg_vw = state.plateSvgVw;
      if (state.plateSvgVh) p.plate_svg_vh = state.plateSvgVh;
      if (state.borderPng) p.border_png = state.borderPng;
      if (state.borderMargin) p.border_margin = state.borderMargin;
      return '/pages/design-studio?' + new URLSearchParams(p).toString();
    }

    function updateUI() {
      var hasSelection = !!state.productId;

      // Right panel
      var emptyEl = document.getElementById('enm-sel-empty');
      var filledEl = document.getElementById('enm-sel-filled');
      var nameEl = document.getElementById('enm-sel-name');
      var collEl = document.getElementById('enm-sel-collection');
      var priceEl = document.getElementById('enm-sel-price');

      if (emptyEl) emptyEl.style.display = hasSelection ? 'none' : '';
      if (filledEl) filledEl.style.display = hasSelection ? 'flex' : 'none';
      if (nameEl) nameEl.textContent = state.productTitle;
      if (collEl) collEl.textContent = COLLECTION_LABELS[state.collection] || '';
      if (priceEl) {
        var cents = parseInt(state.priceMin, 10);
        priceEl.textContent = cents > 0
          ? 'From ' + (window.Shopify && Shopify.formatMoney
              ? Shopify.formatMoney(cents, window._enmMoneyFormat || '{{amount}}')
              : '$' + (cents / 100).toFixed(2))
          : '';
      }

      // Desktop CTA
      if (nextBtn) nextBtn.disabled = !hasSelection;

      // Mobile bottom bar
      var bottomSel = document.getElementById('enm-bottom-selected');
      if (bottomSel) {
        bottomSel.style.display = hasSelection ? '' : 'none';
        bottomSel.textContent = state.productTitle;
      }
      if (mobileNextBtn) mobileNextBtn.disabled = !hasSelection;
    }

    // ── Edit mode key management ──────────────────────────────────────────────
    // Step 2 passes ?from_edit=1 when the Back button is clicked during an edit session.
    // If Step 1 loads without that flag (fresh nav, direct link, logo click, etc.),
    // clear the key so a stale edit session can never silently replace a cart item.
    var _s1Params = new URLSearchParams(window.location.search);
    var _fromEdit = _s1Params.get('from_edit') === '1';
    if (!_fromEdit) {
      try { sessionStorage.removeItem('_enm_edit_line_item_key'); } catch (e) {}
    }

    // ── Restore selection when returning from Step 2 or frontpage ────────────
    // Priority: URL param (set by Step 2 back button) > sessionStorage (survives logo nav)
    var restoreHandle = _s1Params.get('product_handle');
    if (!restoreHandle) {
      try {
        restoreHandle = sessionStorage.getItem('_enm_s1_product_handle') || '';
      } catch (e) {}
    }
    if (restoreHandle) {
      var matchCard = document.querySelector('.enm-s1__card[data-product-handle="' + restoreHandle + '"]');
      if (matchCard) {
        // Open the accordion section that contains this card
        var accItem = matchCard.closest('.enm-s1__acc-item');
        if (accItem) {
          document.querySelectorAll('.enm-s1__acc-item').forEach(function (i) {
            i.classList.remove('enm-s1__acc-item--active');
            i.classList.add('enm-s1__acc-item--inactive');
          });
          accItem.classList.add('enm-s1__acc-item--active');
          accItem.classList.remove('enm-s1__acc-item--inactive');
        }
        // Trigger the card click — sets all state fields and calls updateUI()
        matchCard.click();
        // Scroll the selected card into view after a short paint delay
        setTimeout(function () {
          matchCard.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }, 80);
        return; // updateUI() was called by matchCard.click()
      }
    }

    // Initial render
    updateUI();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enm-step3-review"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    // ── Constants ─────────────────────────────────────────
    var SHOPIFY_PRODUCT_ID = window.enmProductId || null; // set via section setting or global
    var CANVAS_PX_PER_INCH = 72;
    var DPR = window.devicePixelRatio || 1;

    var metalColors = {
      'satin-brass': '#E1C16E', // same base as polished brass
      'polished-brass': '#E1C16E',
      'satin-silver': '#c0c0c0',
      'polished-silver': '#c0c0c0', // same base as satin silver
      'satin-copper': '#a75e4a',
      'black-colored-brass': '#121212',
      'maroon-brass': '#640f24',
      'black-aluminum': '#1a1a1a',
      'black-brass': '#121212', // backward-compat alias
    };

    var metalLabels = {
      'satin-brass': 'Satin Brass',
      'polished-brass': 'Polished Brass',
      'satin-silver': 'Satin Silver',
      'polished-silver': 'Polished Silver',
      'satin-copper': 'Satin Copper',
      'black-colored-brass': 'Black-colored Brass',
      'maroon-brass': 'Maroon Brass',
      'black-aluminum': 'Black Aluminum',
      'black-brass': 'Black-colored Brass', // backward-compat alias
    };

    var mountingLabels = {
      none: 'None (Plain Back)',
      adhesive: 'Industrial Adhesive',
      '2-side-holes': '2 Side Holes + Screws',
      '4-corner-holes': '4 Corner Holes + Screws',
    };

    var metalUpcharge = {
      'satin-brass': 0,
      'polished-brass': 3,
      'satin-silver': 2,
      'polished-silver': 4,
      'satin-copper': 5,
      'black-colored-brass': 4,
      'maroon-brass': 4,
      'black-aluminum': 3,
      'black-brass': 4, // backward-compat alias
    };
    var cornerUpcharge = { square: 0, rounded: 1, notched: 2, scallop: 2, chamfer: 1.5 };
    var mountingUpcharge = { none: 0, adhesive: 2, '2-side-holes': 4.5, '4-corner-holes': 6 };

    // ── Clipart catalog (loaded from assets/enm-cliparts.js) ─────
    var CLIPARTS = window.ENM_CLIPARTS || {};

    // ── Edit mode: user arrived via "Edit Design" in cart ─────────────────────
    var editLineItemKey = null;
    try {
      editLineItemKey = sessionStorage.getItem('_enm_edit_line_item_key');
    } catch (e) {}
    var _editMode = !!editLineItemKey;

    // ── Product-changed notice: edit session where a different product was picked ──
    var _productChanged = false;
    try {
      _productChanged = sessionStorage.getItem('_enm_product_changed') === '1';
    } catch (e) {}
    if (_productChanged) {
      var _pcNotice = document.getElementById('enm-product-changed-notice');
      if (_pcNotice) _pcNotice.style.display = '';
    }

    // ── Load canvas state ─────────────────────────────────
    var canvasState = null;
    try {
      var saved = sessionStorage.getItem('_canvas_state');
      if (saved) canvasState = JSON.parse(saved);
    } catch (e) {}

    // ── Merge mode ────────────────────────────────────────
    var mergeMode = !!(canvasState && canvasState.mergeMode);
    var mergeCount = (canvasState && canvasState.mergeCount) || 1;
    var mergeSequential = (canvasState && canvasState.mergeSequential) || null; // {prefix,start,count,pad}
    var mergeStates = [];
    if (mergeMode) {
      try {
        var ms = sessionStorage.getItem('_enm_merge_states');
        if (ms) mergeStates = JSON.parse(ms);
      } catch (e) {}
    }

    // URL params as fallback spec
    var urlParams = new URLSearchParams(window.location.search);
    var spec = (canvasState && canvasState.spec) || {
      type: urlParams.get('type') || 'rectangular',
      metal: urlParams.get('metal') || 'satin-brass',
      height: parseFloat(urlParams.get('height')) || 2,
      width: parseFloat(urlParams.get('width')) || 4,
      corner: urlParams.get('corner') || 'square',
      mounting: urlParams.get('mounting') || '4-corner-holes',
      mode: urlParams.get('mode') || 'single',
      borderPng: '',
      borderMargin: 0,
    };
    // Restore border fields from canvas state (memorial products)
    if (canvasState && canvasState.borderPng) spec.borderPng = canvasState.borderPng;
    if (canvasState && canvasState.borderMargin) spec.borderMargin = canvasState.borderMargin;
    var layers = (canvasState && canvasState.layers) || [
      {
        id: 1,
        text: 'YOUR TEXT HERE',
        font: 'Inter',
        size: 24,
        spacing: 0,
        align: 'center',
        style: 'deep-black',
        x: 0,
        y: 0,
      },
    ];
    // Carry variant ID and product handle from step 2
    var savedVariantId = (canvasState && canvasState.variantId) || urlParams.get('variant_id') || null;
    var savedProductHandle = (canvasState && canvasState.productHandle) || urlParams.get('product_handle') || null;

    // ── Render proof canvas ───────────────────────────────
    var proofCanvas = document.getElementById('enm-proof-canvas');
    var ctx = proofCanvas.getContext('2d');

    function renderProof() {
      var pw = Math.round(spec.width * CANVAS_PX_PER_INCH);
      var ph = Math.round(spec.height * CANVAS_PX_PER_INCH);

      proofCanvas.style.width = pw + 'px';
      proofCanvas.style.height = ph + 'px';
      proofCanvas.width = pw * DPR;
      proofCanvas.height = ph * DPR;
      ctx.setTransform(DPR, 0, 0, DPR, 0, 0);

      var proofImg = document.getElementById('enm-proof-img');

      // Show stored image (blob URL or local data URL) — no canvas re-render needed
      var proofSrc = canvasState && (canvasState.previewUrl || canvasState.previewPng);
      if (proofSrc) {
        proofCanvas.style.display = 'none';
        if (proofImg) {
          proofImg.style.display = 'block';
          proofImg.style.width = pw + 'px';
          proofImg.src = proofSrc;
          proofImg.style.cursor = 'zoom-in';
          proofImg.onclick = function () {
            openSingleLightbox(proofSrc);
          };
        }
        finishRender(pw, ph);
        return;
      }

      // Fallback: re-render from layer data onto canvas
      if (proofImg) proofImg.style.display = 'none';
      proofCanvas.style.display = '';
      proofCanvas.style.width = pw + 'px';
      proofCanvas.style.height = ph + 'px';
      proofCanvas.width = pw * DPR;
      proofCanvas.height = ph * DPR;
      ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
      renderFromLayers(pw, ph);
    }

    function renderFromLayers(pw, ph) {
      var metalColor = metalColors[spec.metal] || '#e3b448';
      var shapedPath = getScaledShapePath(pw, ph); // non-null for shaped products

      // Plate background
      ctx.save();
      if (shapedPath) {
        ctx.clip(shapedPath);
      } else {
        buildCornerPath(ctx, pw, ph, spec.corner);
        ctx.clip();
      }
      ctx.fillStyle = metalColor;
      ctx.fillRect(0, 0, pw, ph);
      // Metal-specific texture overlay
      if (spec.metal === 'satin-brass' || spec.metal === 'satin-silver' || spec.metal === 'satin-copper') {
        // Satin brush texture — three passes of randomized horizontal strokes.
        var _seed = Math.round(pw * 1000 + ph * 37);
        function _rng() {
          _seed = (_seed * 9301 + 49297) % 233280;
          return _seed / 233280;
        }

        ctx.strokeStyle = '#ffffff';
        ctx.lineWidth = 1;
        var _y = 0;
        while (_y < ph) {
          var _a = 0.025 + _rng() * 0.085;
          if (_rng() > 0.12) {
            ctx.globalAlpha = _a;
            ctx.beginPath();
            ctx.moveTo(0, _y);
            ctx.lineTo(pw, _y);
            ctx.stroke();
          }
          _y += 0.7 + _rng() * 2.1;
        }
        _y = _rng() * 6;
        while (_y < ph) {
          ctx.globalAlpha = 0.1 + _rng() * 0.12;
          ctx.beginPath();
          ctx.moveTo(0, _y);
          ctx.lineTo(pw, _y);
          ctx.stroke();
          _y += 5 + _rng() * 10;
        }
        ctx.strokeStyle = '#000000';
        _y = _rng() * 5;
        while (_y < ph) {
          ctx.globalAlpha = 0.04 + _rng() * 0.07;
          ctx.beginPath();
          ctx.moveTo(0, _y);
          ctx.lineTo(pw, _y);
          ctx.stroke();
          _y += 4 + _rng() * 10;
        }
        ctx.globalAlpha = 1;
      } else if (spec.metal === 'polished-brass' || spec.metal === 'polished-silver') {
        // Polished: narrow spotlight highlight from top-left corner
        var rGrad = ctx.createLinearGradient(0, 0, pw * 0.28, ph * 0.55);
        rGrad.addColorStop(0, 'rgba(255,255,255,0.72)');
        rGrad.addColorStop(0.18, 'rgba(255,255,255,0.38)');
        rGrad.addColorStop(0.42, 'rgba(255,255,255,0.08)');
        rGrad.addColorStop(1, 'rgba(255,255,255,0.0)');
        ctx.fillStyle = rGrad;
        ctx.fillRect(0, 0, pw, ph);
      }
      ctx.restore();

      // Border
      ctx.save();
      ctx.strokeStyle = 'rgba(0,0,0,0.18)';
      ctx.lineWidth = 1;
      if (shapedPath) {
        ctx.stroke(shapedPath);
      } else {
        buildCornerPath(ctx, pw, ph, spec.corner);
        ctx.stroke();
      }
      ctx.restore();

      // Decorative border (memorial products) — clipped to plate shape
      if (spec.borderPng) {
        ctx.save();
        if (shapedPath) {
          ctx.clip(shapedPath);
        } else {
          buildCornerPath(ctx, pw, ph, spec.corner);
          ctx.clip();
        }
        renderBorderLayer(ctx, pw, ph);
        ctx.restore();
      }

      // Holes
      renderHoles(ctx, pw, ph, spec.mounting);

      // Text layers
      layers.forEach(function (layer) {
        renderLayer(ctx, layer, pw, ph);
      });

      finishRender(pw, ph);
    }

    function finishRender(pw, ph) {
      // Update ruler labels
      var rulerH = document.getElementById('enm-ruler-h');
      var rulerV = document.getElementById('enm-ruler-v');
      if (rulerH) rulerH.textContent = spec.width + '\u2033 width';
      if (rulerV) rulerV.textContent = spec.height + '\u2033 height';
    }

    // getScaledShapePath — returns a scaled Path2D for shaped products (spec.shapeSvg set),
    // or null for rectangular products.
    // Derives scale from the path's own coordinate bounds (same approach as step2's svgPathProcess)
    // so no viewBox metafields are needed.
    // Only used in the fallback re-render; the normal flow shows previewPng from step2.
    function getScaledShapePath(pw, ph) {
      if (!spec.shapeSvg) return null;
      try {
        var bb = svgBbox(spec.shapeSvg);
        if (!bb || bb.w === 0 || bb.h === 0) return null;
        var scaled = new Path2D();
        scaled.addPath(
          new Path2D(spec.shapeSvg),
          new DOMMatrix([pw / bb.w, 0, 0, ph / bb.h, (-bb.x * pw) / bb.w, (-bb.y * ph) / bb.h])
        );
        return scaled;
      } catch (e) {
        return null;
      }
    }

    // Minimal SVG path bbox — handles M/m/L/l/C/c/H/h/V/v/A/a (x,y endpoints only)
    function svgBbox(d) {
      var xs = [],
        ys = [];
      var cx = 0,
        cy = 0;
      (d.match(/[MmLlCcSsQqTtAaHhVvZz][^MmLlCcSsQqTtAaHhVvZz]*/g) || []).forEach(function (seg) {
        var cmd = seg[0];
        var nums = seg
          .slice(1)
          .trim()
          .split(/[\s,]+/)
          .filter(Boolean)
          .map(Number);
        var i = 0,
          n = function () {
            return nums[i++] || 0;
          };
        switch (cmd) {
          case 'M':
          case 'L':
          case 'T':
            cx = n();
            cy = n();
            xs.push(cx);
            ys.push(cy);
            break;
          case 'm':
          case 'l':
          case 't':
            cx += n();
            cy += n();
            xs.push(cx);
            ys.push(cy);
            break;
          case 'H':
            cx = n();
            xs.push(cx);
            ys.push(cy);
            break;
          case 'h':
            cx += n();
            xs.push(cx);
            ys.push(cy);
            break;
          case 'V':
            cy = n();
            xs.push(cx);
            ys.push(cy);
            break;
          case 'v':
            cy += n();
            xs.push(cx);
            ys.push(cy);
            break;
          case 'C':
            while (i < nums.length) {
              n();
              n();
              n();
              n();
              cx = n();
              cy = n();
              xs.push(cx);
              ys.push(cy);
            }
            break;
          case 'c':
            while (i < nums.length) {
              n();
              n();
              n();
              n();
              cx += n();
              cy += n();
              xs.push(cx);
              ys.push(cy);
            }
            break;
          case 'Q':
          case 'S':
            while (i < nums.length) {
              n();
              n();
              cx = n();
              cy = n();
              xs.push(cx);
              ys.push(cy);
            }
            break;
          case 'q':
          case 's':
            while (i < nums.length) {
              n();
              n();
              cx += n();
              cy += n();
              xs.push(cx);
              ys.push(cy);
            }
            break;
          case 'A':
            while (i < nums.length) {
              n();
              n();
              n();
              n();
              n();
              cx = n();
              cy = n();
              xs.push(cx);
              ys.push(cy);
            }
            break;
          case 'a':
            while (i < nums.length) {
              n();
              n();
              n();
              n();
              n();
              cx += n();
              cy += n();
              xs.push(cx);
              ys.push(cy);
            }
            break;
        }
      });
      if (!xs.length) return null;
      var x = Math.min.apply(null, xs),
        y = Math.min.apply(null, ys);
      return { x: x, y: y, w: Math.max.apply(null, xs) - x, h: Math.max.apply(null, ys) - y };
    }

    // Foreground (engraved) colors per metal — matches Step 2 metalFg map.
    var metalFgColors = {
      'satin-brass':        '#1A1A1A',
      'polished-brass':     '#1A1A1A',
      'satin-silver':       '#1A1A1A',
      'polished-silver':    '#1A1A1A',
      'satin-copper':       '#1A1A1A',
      'black-colored-brass':'#D4AF37',
      'maroon-brass':       '#D4AF37',
      'black-aluminum':     '#E0E0E0',
      'black-brass':        '#D4AF37',
    };

    // Renders the decorative border for memorial products.
    // Loads spec.borderPng (transparent PNG silhouette), tints to fgColor via source-in.
    // Async: triggers a re-render after the image loads if not already cached.
    // Must be called inside a plate-shape clip so corners are respected.
    var _s3BorderImg = null;
    var _s3BorderImgUrl = '';
    function renderBorderLayer(c, pw, ph) {
      if (!spec.borderPng) return;
      var m = (spec.borderMargin || 0) * CANVAS_PX_PER_INCH;
      var tw = pw - 2 * m;
      var th = ph - 2 * m;
      if (tw <= 0 || th <= 0) return;

      function drawTinted(img) {
        // Tint on offscreen canvas — source-in on the main canvas would erase plate background
        var off = document.createElement('canvas');
        off.width  = Math.ceil(tw);
        off.height = Math.ceil(th);
        var oc = off.getContext('2d');
        oc.drawImage(img, 0, 0, tw, th);
        oc.globalCompositeOperation = 'source-in';
        oc.fillStyle = metalFgColors[spec.metal] || '#1A1A1A';
        oc.fillRect(0, 0, tw, th);
        c.drawImage(off, m, m);
      }

      if (_s3BorderImgUrl === spec.borderPng && _s3BorderImg) {
        drawTinted(_s3BorderImg);
        return;
      }
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        _s3BorderImg = img;
        _s3BorderImgUrl = spec.borderPng;
        drawTinted(img);
      };
      img.src = spec.borderPng;
    }

    function buildCornerPath(c, pw, ph, corner) {
      // All radii/cuts: physical inches × 72 PPI (no zoom in step3)
      c.beginPath();
      switch (corner) {
        case 'rounded': {
          // 1/8" (9px) for plates ≤ 0.5" tall; 3/16" (13.5px) for taller
          var r = spec.height <= 0.5 ? 9 : 13.5;
          c.moveTo(r, 0);
          c.lineTo(pw - r, 0);
          c.arcTo(pw, 0, pw, r, r);
          c.lineTo(pw, ph - r);
          c.arcTo(pw, ph, pw - r, ph, r);
          c.lineTo(r, ph);
          c.arcTo(0, ph, 0, ph - r, r);
          c.lineTo(0, r);
          c.arcTo(0, 0, r, 0, r);
          break;
        }
        case 'notched': {
          // Concave quarter-circle cut, r = 3/16" = 13.5px
          var n = 13.5;
          c.moveTo(n, 0);
          c.lineTo(pw - n, 0);
          c.arc(pw, 0, n, Math.PI, Math.PI / 2, true);
          c.lineTo(pw, ph - n);
          c.arc(pw, ph, n, (3 * Math.PI) / 2, Math.PI, true);
          c.lineTo(n, ph);
          c.arc(0, ph, n, 0, (3 * Math.PI) / 2, true);
          c.lineTo(0, n);
          c.arc(0, 0, n, Math.PI / 2, 0, true);
          break;
        }
        case 'chamfer': {
          // Straight diagonal cut, c = 1/4" = 18px
          var ch = 14.4;
          c.moveTo(ch, 0);
          c.lineTo(pw - ch, 0);
          c.lineTo(pw, ch);
          c.lineTo(pw, ph - ch);
          c.lineTo(pw - ch, ph);
          c.lineTo(ch, ph);
          c.lineTo(0, ph - ch);
          c.lineTo(0, ch);
          break;
        }
        case 'scallop': {
          // Convex 180° tab at each corner. Center = s/2 inward from corner, radius = s/√2
          var s = 18,
            h = s / 2,
            r = s / Math.SQRT2;
          c.moveTo(s, 0);
          c.lineTo(pw - s, 0);
          c.arc(pw - h, h, r, (5 * Math.PI) / 4, Math.PI / 4, false); // top-right
          c.lineTo(pw, ph - s);
          c.arc(pw - h, ph - h, r, (7 * Math.PI) / 4, (3 * Math.PI) / 4, false); // bottom-right
          c.lineTo(s, ph);
          c.arc(h, ph - h, r, Math.PI / 4, (5 * Math.PI) / 4, false); // bottom-left
          c.lineTo(0, s);
          c.arc(h, h, r, (3 * Math.PI) / 4, (7 * Math.PI) / 4, false); // top-left
          break;
        }
        default:
          c.rect(0, 0, pw, ph);
      }
      c.closePath();
    }

    // Screw head color palettes — mirrors step2 exactly.
    // Metals: satin/polished/black-colored/maroon/black brass → gold
    //         satin/polished silver + black-aluminum           → silver
    //         satin copper                                     → black
    var SCREW_COLOR_MAP = {
      'satin-brass': 'gold',
      'polished-brass': 'gold',
      'black-colored-brass': 'gold',
      'maroon-brass': 'gold',
      'black-brass': 'gold',
      'satin-silver': 'silver',
      'polished-silver': 'silver',
      'black-aluminum': 'silver',
      'satin-copper': 'black',
    };
    var SCREW_PALETTES = {
      gold: { hi: '#E8C870', mid: '#C8943A', rim: '#987030', cross: '#6A4C18' },
      silver: { hi: '#E0E0E0', mid: '#B0B0B0', rim: '#808080', cross: '#505050' },
      black: { hi: '#787878', mid: '#3C3C3C', rim: '#181818', cross: '#060606' },
    };

    function drawScrewHead(c, cx, cy, r) {
      var pal = SCREW_PALETTES[SCREW_COLOR_MAP[spec.metal] || 'gold'];
      var grad = c.createRadialGradient(cx - r * 0.3, cy - r * 0.3, r * 0.05, cx, cy, r);
      grad.addColorStop(0, pal.hi);
      grad.addColorStop(0.5, pal.mid);
      grad.addColorStop(1, pal.rim);
      c.beginPath();
      c.arc(cx, cy, r, 0, Math.PI * 2);
      c.fillStyle = grad;
      c.fill();
      c.strokeStyle = 'rgba(0,0,0,0.25)';
      c.lineWidth = 0.5;
      c.stroke();
      c.save();
      c.beginPath();
      c.arc(cx, cy, r, 0, Math.PI * 2);
      c.clip();
      var sw = r * 0.36,
        sl = r * 0.82;
      c.fillStyle = pal.cross;
      c.fillRect(cx - sl, cy - sw / 2, sl * 2, sw);
      c.fillRect(cx - sw / 2, cy - sl, sw, sl * 2);
      c.restore();
    }

    function renderHoles(c, pw, ph, mounting) {
      if (mounting === 'none' || mounting === 'adhesive') return;
      var hr = 5,
        m = 11;
      var positions =
        mounting === '4-corner-holes'
          ? [
              [m, m],
              [pw - m, m],
              [m, ph - m],
              [pw - m, ph - m],
            ]
          : [
              [m, ph / 2],
              [pw - m, ph / 2],
            ];
      positions.forEach(function (pos) {
        drawScrewHead(c, pos[0], pos[1], hr);
      });
    }

    function renderLayer(c, layer, pw, ph) {
      if (layer.visible === false) return; // hidden template layer
      var darkMetals = ['black-colored-brass', 'black-brass', 'maroon-brass', 'black-aluminum'];
      var engColor = darkMetals.indexOf(spec.metal) !== -1 ? 'rgba(220,200,160,0.9)' : 'rgba(30,20,10,0.82)';
      // Hex version of engColor for barcode pixel recoloring
      var engColorHex = darkMetals.indexOf(spec.metal) !== -1 ? '#dcc8a0' : '#1e140a';

      // layer.x / layer.y: inches from plate centre (positive right / positive down)
      var cx = pw / 2 + (layer.x || 0) * CANVAS_PX_PER_INCH;
      var cy = ph / 2 + (layer.y || 0) * CANVAS_PX_PER_INCH;
      var rot = ((layer.rotation || 0) * Math.PI) / 180;

      if (layer.type === 'barcode-1d' || layer.type === 'barcode-2d') {
        renderBarcodeS3(c, layer, pw, ph, engColorHex);
        return;
      }

      if (layer.type === 'clipart') {
        var art = CLIPARTS[layer.clipartId];
        if (!art) return;
        var r = ((layer.clipartSize || 1) * CANVAS_PX_PER_INCH) / 2;
        var cStyle = layer.style || 'outline';
        c.save();
        c.translate(cx, cy);
        var csx = layer.scaleX || 1,
          csy = layer.scaleY || 1;
        if (rot) c.rotate(rot);
        if (csx !== 1 || csy !== 1) c.scale(csx, csy);
        c.fillStyle = engColor;
        c.strokeStyle = engColor;

        if (art.pathData) {
          // SVG-based clipart: apply viewBox→canvas transform, use Path2D
          var maxDim = Math.max(art.vbW, art.vbH);
          var s = (r * 2) / maxDim;
          var path2d = new Path2D(art.pathData);
          c.translate(-art.vbCx * s, -art.vbCy * s);
          c.scale(s, s);
          switch (cStyle) {
            case 'filled':
              c.fill(path2d);
              break;
            case 'hairline':
              c.lineWidth = Math.max(1, r * 0.04) / s;
              c.stroke(path2d);
              break;
            default:
              c.lineWidth = Math.max(1.5, r * 0.06) / s;
              c.stroke(path2d);
          }
        } else {
          // Geometric clipart (draw-function approach)
          art.draw(c, 0, 0, r);
          switch (cStyle) {
            case 'filled':
              c.fill();
              break;
            case 'hairline':
              c.lineWidth = Math.max(1, r * 0.04);
              c.stroke();
              break;
            default:
              c.lineWidth = Math.max(1.5, r * 0.06);
              c.stroke();
          }
        }
        c.restore();
        return;
      }

      // Text layer
      var align = layer.align || 'center';
      var fontSize = layer.size || 24;
      var lineSpacing = layer.lineSpacing || 1.4;
      var lineHeightPx = fontSize * lineSpacing;
      var lines = (layer.text || '').split('\n');

      c.save();
      c.translate(cx, cy);
      var tsx = layer.scaleX || 1,
        tsy = layer.scaleY || 1;
      if (rot) c.rotate(rot);
      if (tsx !== 1 || tsy !== 1) c.scale(tsx, tsy);

      c.font = fontSize + 'px "' + (layer.font || 'Inter') + '"';
      c.letterSpacing = (layer.spacing || 0) + 'px';
      c.textBaseline = 'middle';
      c.textAlign = align;
      c.fillStyle = engColor;
      c.strokeStyle = engColor;

      var startY = -((lines.length - 1) / 2) * lineHeightPx;
      var xOff = 0; // text is centred on (0,0) after translate

      lines.forEach(function (line, i) {
        var lineY = startY + i * lineHeightPx;

        // Engraved bevel — dark shadow offset top-left, light highlight offset bottom-right.
        // Skipped for stroke-only styles and small text.
        if (layer.style !== 'outline' && layer.style !== 'hairline' && fontSize >= 12) {
          c.fillStyle = 'rgba(0,0,0,0.45)';
          c.fillText(line, xOff - 0.5, lineY - 0.5);
          c.fillStyle = 'rgba(255,255,255,0.25)';
          c.fillText(line, xOff + 0.5, lineY + 0.5);
          c.fillStyle = engColor; // restore for main draw below
        }

        switch (layer.style) {
          case 'outline':
            c.lineWidth = Math.max(0.5, fontSize * 0.04);
            c.strokeText(line, xOff, lineY);
            break;
          case 'filled':
            c.fillText(line, xOff, lineY);
            break;
          case 'hairline':
            c.lineWidth = Math.max(0.3, fontSize * 0.02);
            c.strokeText(line, xOff, lineY);
            break;
          default: // deep-black
            c.fillText(line, xOff, lineY);
        }
      });

      c.restore();
    }

    // ── Barcode / 2D code rendering (Step 3 read-only) ───────
    // Same pixel-recolor approach as Step 2. Requires bwip-js from CDN.
    var _s3BcidMap = {
      CODE128: 'code128', CODE39: 'code39', EAN13: 'ean13', EAN8: 'ean8',
      UPCA: 'upca', ITF14: 'itf14', datamatrix: 'datamatrix', qrcode: 'qrcode'
    };

    function renderBarcodeS3(c, layer, pw, ph, colorHex) {
      if (typeof bwipjs === 'undefined') return;
      var layerW, layerH, layerX, layerY;
      if (layer.type === 'barcode-1d') {
        layerW = (layer.width || 1.8) * CANVAS_PX_PER_INCH * (layer.scaleX || 1);
        layerH = (layer.height || 0.4) * CANVAS_PX_PER_INCH * (layer.scaleY || 1);
      } else {
        var sz = (layer.size || 0.5) * CANVAS_PX_PER_INCH;
        layerW = sz * (layer.scaleX || 1);
        layerH = sz * (layer.scaleY || 1);
      }
      var layerCx = pw / 2 + (layer.x || 0) * CANVAS_PX_PER_INCH;
      var layerCy = ph / 2 + (layer.y || 0) * CANVAS_PX_PER_INCH;
      layerX = layerCx - layerW / 2;
      layerY = layerCy - layerH / 2;
      if (layerW < 2 || layerH < 2) return;

      var content = layer.content || '';
      if (!content) content = layer.type === 'barcode-2d' ? 'ENM-001' : '12345678';

      var bcid = _s3BcidMap[layer.format] || (layer.type === 'barcode-2d' ? 'datamatrix' : 'code128');
      var _ucFmts = { CODE39: 1, ITF14: 1, code39: 1, itf14: 1 };
      if (_ucFmts[layer.format]) content = content.toUpperCase();
      var oc = document.createElement('canvas');
      try {
        bwipjs.toCanvas(oc, {
          bcid: bcid,
          text: content,
          scale: 2,
          height: 10,
          includetext: (layer.type === 'barcode-1d' && layer.showText !== false),
          paddingwidth: 0, paddingheight: 0,
        });
      } catch (e) {
        c.save();
        c.setLineDash([3, 3]);
        c.strokeStyle = '#ef4444';
        c.lineWidth = 1;
        c.strokeRect(layerX, layerY, layerW, layerH);
        c.setLineDash([]);
        c.restore();
        return;
      }

      // Recolor: dark → colorHex, light → transparent
      var octx = oc.getContext('2d');
      var imgD = octx.getImageData(0, 0, oc.width, oc.height);
      var d = imgD.data;
      var cr = parseInt(colorHex.slice(1, 3), 16);
      var cg = parseInt(colorHex.slice(3, 5), 16);
      var cb = parseInt(colorHex.slice(5, 7), 16);
      for (var pi = 0; pi < d.length; pi += 4) {
        var lum = (d[pi] * 299 + d[pi + 1] * 587 + d[pi + 2] * 114) / 1000;
        if (lum < 128 && d[pi + 3] > 0) {
          d[pi] = cr; d[pi + 1] = cg; d[pi + 2] = cb; d[pi + 3] = 255;
        } else {
          d[pi + 3] = 0;
        }
      }
      octx.putImageData(imgD, 0, 0);

      c.save();
      if (layer.inverted) {
        c.fillStyle = colorHex;
        c.fillRect(layerX, layerY, layerW, layerH);
        c.globalCompositeOperation = 'destination-out';
        c.drawImage(oc, layerX, layerY, layerW, layerH);
      } else {
        c.drawImage(oc, layerX, layerY, layerW, layerH);
      }
      c.restore();
    }

    // ── Merge grid ────────────────────────────────────────
    function renderMergeGrid() {
      var grid = document.getElementById('enm-merge-grid');
      if (!grid) return;
      grid.innerHTML = '';
      mergeStates.forEach(function (item, i) {
        var cell = document.createElement('div');
        cell.className = 'enm-s3__merge-cell';

        var img = document.createElement('img');
        img.className = 'enm-s3__merge-cell-img';
        img.src = item.thumbnailUrl || '';
        img.alt = 'Plate ' + (i + 1);
        cell.appendChild(img);

        var num = document.createElement('div');
        num.className = 'enm-s3__merge-cell-num';
        num.textContent = item.seqLabel ? item.seqLabel + ': ' + item.text : '#' + (i + 1);
        cell.appendChild(num);

        var cellIndex = i;
        cell.addEventListener('click', function () {
          openLightbox(cellIndex);
        });

        grid.appendChild(cell);
      });
    }

    // ── Lightbox ──────────────────────────────────────────
    var _lightbox = document.getElementById('enm-lightbox');
    var _lightboxImg = document.getElementById('enm-lightbox-img');
    var _lightboxCtr = document.getElementById('enm-lightbox-counter');
    var _lightboxPrev = document.getElementById('enm-lightbox-prev');
    var _lightboxNext = document.getElementById('enm-lightbox-next');
    var _lightboxIndex = 0;

    function showLightboxAt(idx) {
      _lightboxIndex = idx;
      var item = mergeStates[idx];
      if (!item || !_lightboxImg) return;
      _lightboxImg.src = item.thumbnailUrl || '';
      if (_lightboxCtr) _lightboxCtr.textContent = 'Variation ' + (idx + 1) + ' of ' + mergeStates.length;
      if (_lightboxPrev) _lightboxPrev.disabled = idx === 0;
      if (_lightboxNext) _lightboxNext.disabled = idx === mergeStates.length - 1;
    }

    function openLightbox(idx) {
      if (!_lightbox) return;
      var navBar = _lightbox.querySelector('.enm-lightbox__nav-bar');
      if (navBar) navBar.style.display = '';
      showLightboxAt(idx);
      _lightbox.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    }

    function openSingleLightbox(src) {
      if (!_lightbox || !_lightboxImg) return;
      var navBar = _lightbox.querySelector('.enm-lightbox__nav-bar');
      if (navBar) navBar.style.display = 'none';
      _lightboxImg.src = src;
      _lightbox.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    }

    function closeLightbox() {
      if (!_lightbox) return;
      _lightbox.style.display = 'none';
      document.body.style.overflow = '';
      if (_lightboxImg) _lightboxImg.src = '';
    }

    if (_lightbox) {
      _lightbox.addEventListener('click', function (e) {
        if (e.target === _lightbox) closeLightbox();
      });
      var _lbClose = document.getElementById('enm-lightbox-close');
      if (_lbClose) _lbClose.addEventListener('click', closeLightbox);
      if (_lightboxPrev)
        _lightboxPrev.addEventListener('click', function (e) {
          e.stopPropagation();
          if (_lightboxIndex > 0) showLightboxAt(_lightboxIndex - 1);
        });
      if (_lightboxNext)
        _lightboxNext.addEventListener('click', function (e) {
          e.stopPropagation();
          if (_lightboxIndex < mergeStates.length - 1) showLightboxAt(_lightboxIndex + 1);
        });
      document.addEventListener('keydown', function (e) {
        if (_lightbox.style.display === 'none') return;
        if (e.key === 'Escape') closeLightbox();
        if (e.key === 'ArrowLeft' && _lightboxIndex > 0) showLightboxAt(_lightboxIndex - 1);
        if (e.key === 'ArrowRight' && _lightboxIndex < mergeStates.length - 1) showLightboxAt(_lightboxIndex + 1);
      });
    }

    // ── Summary UI ───────────────────────────────────────
    function setText(id, val) {
      var el = document.getElementById(id);
      if (el) el.textContent = val;
    }

    function formatPrice(n) {
      return '$' + n.toFixed(2);
    }

    function updateSummary() {
      // Option labels — use Shopify names saved from Step 2
      var sizeLabel = (canvasState && canvasState.sizeOptionName) || 'Size';
      setText('enm-r-size-label', sizeLabel);
      setText('enm-r-size-label-2', sizeLabel);

      // Option values — use the raw Shopify strings, never reformatted
      var sizeVal = (canvasState && canvasState.sizeDisplayVal) || (function () {
        // Fallback: format from spec dims using fractional notation (e.g. '1/2" W x 3-1/2" H').
        // Only reached if sizeDisplayVal was not saved — mirrors step2 formatSizeDims logic.
        function _toFrac(v) {
          var e = Math.round(v * 8), w = Math.floor(e / 8), r = e - w * 8;
          var f = ['','1/8','1/4','3/8','1/2','5/8','3/4','7/8'][r] || '';
          return f ? (w ? w + '-' + f : f) + '"' : w + '"';
        }
        return _toFrac(spec.height) + ' H x ' + _toFrac(spec.width) + ' W';
      })();
      var mountVal = (canvasState && canvasState.mountingDisplayVal) || spec.mounting;
      var metalVal =
        (canvasState && canvasState.lineItemExtras && canvasState.lineItemExtras['Metal & Finish']) ||
        metalLabels[spec.metal] ||
        spec.metal;
      var cornerVal =
        (canvasState && canvasState.lineItemExtras && canvasState.lineItemExtras['Corner Shape']) ||
        spec.corner.charAt(0).toUpperCase() + spec.corner.slice(1);
      var productName = (canvasState && canvasState.productName) || '';

      setText('enm-r-size', sizeVal);
      setText('enm-r-metal', metalVal);
      setText('enm-r-corner', cornerVal);
      setText('enm-r-mounting', mountVal);
      setText('enm-r-type', productName);
      setText('enm-r-size-2', sizeVal);
      setText('enm-r-metal-2', metalVal);
      setText('enm-r-corner-2', cornerVal);
      setText('enm-r-mounting-2', mountVal);

      // Qty display
      var qty = mergeMode ? mergeCount : 1;
      setText('enm-r-qty', qty.toString());

      // Price
      var vPrice = canvasState && canvasState.variantPrice;
      var unitPrice = vPrice != null ? parseFloat(vPrice) / 100 : null;
      var totalPrice = unitPrice != null ? unitPrice * qty : null;

      // Per-plate row: only shown in batch mode
      var unitRow = document.getElementById('enm-price-unit-row');
      if (unitRow) unitRow.style.display = mergeMode ? '' : 'none';
      setText('enm-r-unit-price', unitPrice != null ? '$' + unitPrice.toFixed(2) : '—');
      setText('enm-r-total', totalPrice != null ? '$' + totalPrice.toFixed(2) : '—');

      // Back link — return to Step 2 product page.
      // Full canvas state is in sessionStorage (_canvas_state) — no URL params needed.
      var backLink = document.getElementById('enm-back-link');
      if (backLink) {
        backLink.href = savedProductHandle ? '/products/' + savedProductHandle : '/pages/design-select';
      }
    }

    // ── Upload PNG + JSON to Vercel (deferred from Step 2) ──
    function uploadPngAndJson(onDone) {
      var endpoint = window.ENM_VERCEL_UPLOAD_ENDPOINT;
      // Skip if already uploaded (previewUrl present) or nothing to upload
      if (!endpoint || !canvasState || canvasState.previewUrl) {
        onDone();
        return;
      }
      var prefix = 'files/' + (savedProductHandle || 'design').replace(/[^a-z0-9-]/gi, '-') + '-' + Date.now();
      var pending = 0;

      function done() {
        if (--pending > 0) return;
        onDone();
      }

      var pngDataUrl = canvasState.previewPng;
      if (pngDataUrl) {
        pending++;
        fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            filename: prefix + '.png',
            content: pngDataUrl.replace(/^data:image\/png;base64,/, ''),
            contentType: 'image/png',
          }),
        })
          .then(function (r) {
            return r.json();
          })
          .then(function (d) {
            if (d.url) canvasState.previewUrl = d.url;
            done();
          })
          .catch(function () {
            done();
          });
      }

      var designState = {
        spec: canvasState.spec,
        layers: canvasState.layers,
        variantId: canvasState.variantId,
        variantPrice: canvasState.variantPrice,
        sizeDisplayVal: canvasState.sizeDisplayVal,
        sizeOptionName: canvasState.sizeOptionName,
        productHandle: canvasState.productHandle,
        collection: canvasState.collection,
        productName: canvasState.productName,
        lineItemExtras: canvasState.lineItemExtras,
        mountingDisplayVal: canvasState.mountingDisplayVal,
      };
      pending++;
      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          filename: prefix + '.json',
          content: JSON.stringify(designState),
          contentType: 'application/json',
        }),
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (d) {
          if (d.url) canvasState.stateUrl = d.url;
          done();
        })
        .catch(function () {
          done();
        });

      if (pending === 0) onDone();
    }

    // ── Batch helpers ─────────────────────────────────────

    // Clone layers with merge row i resolved to a plain text layer
    function resolveLayersForRow(rowIndex) {
      return layers.map(function (layer) {
        if (!layer.isMergeField) return layer;
        var mv = (layer.mergeValues && layer.mergeValues[rowIndex]) || {};
        var resolved = {};
        Object.keys(layer).forEach(function (k) {
          resolved[k] = layer[k];
        });
        resolved.text = mv.text || '';
        if (layer.mergeStyleUnlocked) {
          if (mv.font != null) resolved.font = mv.font;
          if (mv.size != null) resolved.size = mv.size;
          if (mv.bold != null) resolved.bold = mv.bold;
          if (mv.italic != null) resolved.italic = mv.italic;
          if (mv.underline != null) resolved.underline = mv.underline;
          if (mv.spacing != null) resolved.spacing = mv.spacing;
          if (mv.align != null) resolved.align = mv.align;
          if (mv.rotation != null) resolved.rotation = mv.rotation;
        }
        // Strip merge-specific fields — generateSvg treats this as a plain text layer
        delete resolved.isMergeField;
        delete resolved.mergeStyleUnlocked;
        delete resolved.mergeValues;
        delete resolved._mergePreviewIndex;
        return resolved;
      });
    }

    // Draw N thumbnails into a 4-col composite PNG, return data URL via callback
    function stitchCompositePng(onDone) {
      var cols = 4;
      var cellW = 200;
      var cellH = Math.round(cellW * (spec.height / spec.width));
      var pad = 8;
      var nRows = Math.ceil(mergeStates.length / cols);
      var oc = document.createElement('canvas');
      oc.width = cols * (cellW + pad) + pad;
      oc.height = nRows * (cellH + pad) + pad;
      var oc2 = oc.getContext('2d');
      oc2.fillStyle = '#f4f7fa';
      oc2.fillRect(0, 0, oc.width, oc.height);

      var total = mergeStates.length;
      if (total === 0) {
        onDone(oc.toDataURL('image/png', 0.85));
        return;
      }

      var loaded = 0;
      mergeStates.forEach(function (item, i) {
        var img = new Image();
        img.onload = function () {
          var col = i % cols;
          var row = Math.floor(i / cols);
          oc2.drawImage(img, pad + col * (cellW + pad), pad + row * (cellH + pad), cellW, cellH);
          if (++loaded === total) onDone(oc.toDataURL('image/png', 0.85));
        };
        img.onerror = function () {
          if (++loaded === total) onDone(oc.toDataURL('image/png', 0.85));
        };
        img.src = item.thumbnailUrl || '';
      });
    }

    // Upload batch design state JSON (includes svgUrls), return blob URL via callback
    function uploadBatchStateJson(prefix, endpoint, compositeUrl, svgUrls, onDone) {
      var designState = {
        spec: canvasState.spec,
        layers: canvasState.layers, // full layers with mergeValues
        mergeMode: true,
        mergeCount: mergeCount,
        svgUrls: svgUrls,
        compositeUrl: compositeUrl,
        variantId: canvasState.variantId,
        variantPrice: canvasState.variantPrice,
        sizeDisplayVal: canvasState.sizeDisplayVal,
        sizeOptionName: canvasState.sizeOptionName,
        productHandle: canvasState.productHandle,
        collection: canvasState.collection,
        productName: canvasState.productName,
        lineItemExtras: canvasState.lineItemExtras,
        mountingDisplayVal: canvasState.mountingDisplayVal,
      };
      if (!endpoint) {
        onDone('');
        return;
      }
      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          filename: prefix + '-state.json',
          content: JSON.stringify(designState),
          contentType: 'application/json',
        }),
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (d) {
          onDone(d.url || '');
        })
        .catch(function () {
          onDone('');
        });
    }

    // ── Add / Update Cart ─────────────────────────────────
    var cartBtn = document.getElementById('enm-cart-btn');
    if (cartBtn) {
      cartBtn.addEventListener('click', function () {
        cartBtn.disabled = true;
        var btnTextEl = document.getElementById('enm-cart-btn-text');

        // lineItemExtras: non-variant options injected by Step 2 (Metal & Finish, Corner Shape)
        var lineItemExtras = (canvasState && canvasState.lineItemExtras) || {};
        if (!lineItemExtras['Metal & Finish']) {
          lineItemExtras['Metal & Finish'] = metalLabels[spec.metal] || spec.metal;
        }

        // Read special instructions before building properties so it is included in every cart path
        var noteEl = document.getElementById('enm-order-note');
        var noteVal = noteEl ? noteEl.value.trim() : '';

        // Base line item properties (svg_url added after upload below)
        // Keys without a leading _ are shown on the Shopify cart page and in admin order details.
        var lineItemProperties = {
          _preview_url: (canvasState && canvasState.previewUrl) || '',
          _product_handle: savedProductHandle || '',
          _collection: (canvasState && canvasState.collection) || '',
        };
        if (canvasState && canvasState.stateUrl) {
          lineItemProperties['_design_state_url'] = canvasState.stateUrl;
        }
        Object.keys(lineItemExtras).forEach(function (k) {
          lineItemProperties[k] = lineItemExtras[k];
        });
        // Special instructions: stored as a visible line-item property so it appears
        // next to the item on the cart page and in the admin order detail per line item.
        if (noteVal) {
          lineItemProperties['Special Instructions'] = noteVal;
        }

        function onSuccess(isUpdate) {
          try {
            if (isUpdate) sessionStorage.removeItem('_enm_edit_line_item_key');
            sessionStorage.removeItem('_enm_product_changed');
          } catch (e) {}
          if (btnTextEl) btnTextEl.textContent = isUpdate ? 'Cart Updated!' : 'Added to Cart!';
          cartBtn.classList.add('enm-s3__cart-btn--success');
          setTimeout(function () { window.location.href = '/cart'; }, 1200);
        }

        function onError(msg) {
          cartBtn.disabled = false;
          var defaultLabel = mergeMode
            ? 'Add ' + mergeCount + ' Plates to Cart'
            : _editMode
            ? 'Update Cart Item'
            : 'Approve \u0026 Add to Cart';
          if (btnTextEl) btnTextEl.textContent = defaultLabel;
          var errBanner = document.getElementById('enm-error-banner');
          errBanner.textContent = msg || 'Failed. Please try again.';
          errBanner.style.display = '';
        }

        // Add a brand-new line item (used when product changes during edit, or normal add)
        // isUpdate=true shows "Cart Updated!", false shows "Added to Cart!"
        function addNewVariant(props, qty, isUpdate) {
          var variantId = savedVariantId || cartBtn.dataset.variantId || window.enmDefaultVariantId || null;
          if (!variantId) {
            window.location.href = '/cart';
            return Promise.resolve();
          }
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: qty || 1, properties: props }] }),
          })
            .then(function (res) {
              if (!res.ok) throw new Error();
              return res.json();
            })
            .then(function () {
              onSuccess(!!isUpdate);
            });
        }

        function submitCart(props) {
          if (_editMode && editLineItemKey) {
            fetch('/cart.js')
              .then(function (r) {
                return r.json();
              })
              .then(function (cart) {
                var oldItem = null;
                for (var i = 0; i < cart.items.length; i++) {
                  if (cart.items[i].key === editLineItemKey) {
                    oldItem = cart.items[i];
                    break;
                  }
                }
                if (!oldItem) {
                  // Line item no longer in cart — add as new
                  return addNewVariant(props, 1, true);
                }
                var newVid = String(savedVariantId || cartBtn.dataset.variantId || window.enmDefaultVariantId || '');
                if (newVid && String(oldItem.variant_id) !== newVid) {
                  // Product/variant changed — remove old item then add new one
                  return fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                    body: JSON.stringify({ id: editLineItemKey, quantity: 0 }),
                  })
                    .then(function (res) {
                      if (!res.ok) throw new Error();
                      return res.json();
                    })
                    .then(function () {
                      return addNewVariant(props, oldItem.quantity, true);
                    });
                }
                // Same variant — update properties only
                return fetch('/cart/change.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                  body: JSON.stringify({ id: editLineItemKey, quantity: oldItem.quantity, properties: props }),
                })
                  .then(function (res) {
                    if (!res.ok) throw new Error();
                    return res.json();
                  })
                  .then(function () {
                    onSuccess(true);
                  });
              })
              .catch(function () {
                onError();
              });
          } else {
            addNewVariant(props, 1, false).catch(function () {
              onError();
            });
          }
        }

        // ── Batch mode: composite PNG + N SVGs + qty cart ─────────────────
        if (mergeMode) {
          var batchEndpoint = window.ENM_VERCEL_UPLOAD_ENDPOINT;
          var batchGenerator = window.ENM_SVG_GENERATOR;
          var batchPrefix = 'files/' + (savedProductHandle || 'design').replace(/[^a-z0-9-]/gi, '-') + '-' + Date.now();
          var variantIdBatch = savedVariantId || cartBtn.dataset.variantId || window.enmDefaultVariantId || null;
          if (!variantIdBatch) {
            onError('No variant ID found.');
            return;
          }

          if (btnTextEl) btnTextEl.textContent = 'Uploading designs\u2026';

          stitchCompositePng(function (compositePngDataUrl) {
            // 1. Upload composite PNG
            function afterCompositeUpload(compositeUrl) {
              // 2. Generate N SVGs sequentially, then upload JSON, then cart
              var svgUrls = [];
              var rowIdx = 0;

              function processNextSvg() {
                if (!batchGenerator || rowIdx >= mergeCount) {
                  // All SVGs done — upload state JSON then POST to cart
                  uploadBatchStateJson(batchPrefix, batchEndpoint, compositeUrl, svgUrls, function (stateUrl) {
                    lineItemProperties['_preview_url'] = compositeUrl;
                    lineItemProperties['_design_state_url'] = stateUrl;
                    lineItemProperties['_is_merge'] = 'true';
                    if (btnTextEl) btnTextEl.textContent = _editMode ? 'Updating cart\u2026' : 'Adding to cart\u2026';

                    function afterBatchCart(isUpdate) {
                      try {
                        sessionStorage.removeItem('_enm_merge_states');
                      } catch (e) {}
                      onSuccess(isUpdate);
                    }

                    if (_editMode && editLineItemKey) {
                      fetch('/cart.js')
                        .then(function (r) {
                          return r.json();
                        })
                        .then(function (cart) {
                          var batchOldItem = null;
                          for (var bi = 0; bi < cart.items.length; bi++) {
                            if (cart.items[bi].key === editLineItemKey) {
                              batchOldItem = cart.items[bi];
                              break;
                            }
                          }
                          var batchNewVid = String(variantIdBatch);
                          if (!batchOldItem || (batchNewVid && String(batchOldItem.variant_id) !== batchNewVid)) {
                            // Product changed or item gone — remove old (if exists) then add new
                            var removeStep = batchOldItem
                              ? fetch('/cart/change.js', {
                                  method: 'POST',
                                  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                                  body: JSON.stringify({ id: editLineItemKey, quantity: 0 }),
                                }).then(function (r) {
                                  if (!r.ok) throw new Error();
                                  return r.json();
                                })
                              : Promise.resolve();
                            return removeStep
                              .then(function () {
                                return fetch('/cart/add.js', {
                                  method: 'POST',
                                  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                                  body: JSON.stringify({
                                    items: [
                                      {
                                        id: parseInt(variantIdBatch, 10),
                                        quantity: mergeCount,
                                        properties: lineItemProperties,
                                      },
                                    ],
                                  }),
                                });
                              })
                              .then(function (res) {
                                if (!res.ok) throw new Error();
                                return res.json();
                              })
                              .then(function () {
                                afterBatchCart(true);
                              });
                          }
                          return fetch('/cart/change.js', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                            body: JSON.stringify({
                              id: editLineItemKey,
                              quantity: mergeCount,
                              properties: lineItemProperties,
                            }),
                          })
                            .then(function (res) {
                              if (!res.ok) throw new Error();
                              return res.json();
                            })
                            .then(function () {
                              afterBatchCart(true);
                            });
                        })
                        .catch(function () {
                          onError('Failed to update cart. Please try again.');
                        });
                    } else {
                      fetch('/cart/add.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                        body: JSON.stringify({
                          items: [
                            { id: parseInt(variantIdBatch, 10), quantity: mergeCount, properties: lineItemProperties },
                          ],
                        }),
                      })
                        .then(function (res) {
                          if (!res.ok) throw new Error();
                          return res.json();
                        })
                        .then(function () {
                          afterBatchCart(false);
                        })
                        .catch(function () {
                          onError('Failed to add to cart. Please try again.');
                        });
                    }
                  });
                  return;
                }

                var currentRow = rowIdx++;
                if (btnTextEl)
                  btnTextEl.textContent = 'Generating plate ' + (currentRow + 1) + ' of ' + mergeCount + '\u2026';

                var resolvedState = { spec: spec, layers: resolveLayersForRow(currentRow) };
                batchGenerator
                  .generateSvg(resolvedState)
                  .then(function (svgString) {
                    return batchGenerator.uploadToBlob(
                      svgString,
                      batchEndpoint,
                      batchPrefix + '-plate-' + (currentRow + 1) + '.svg'
                    );
                  })
                  .then(function (svgUrl) {
                    svgUrls.push(svgUrl);
                    processNextSvg();
                  })
                  .catch(function () {
                    svgUrls.push('');
                    processNextSvg();
                  });
              }

              processNextSvg();
            }

            if (!batchEndpoint) {
              afterCompositeUpload(compositePngDataUrl);
              return;
            }
            fetch(batchEndpoint, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                filename: batchPrefix + '-composite.png',
                content: compositePngDataUrl.replace(/^data:image\/png;base64,/, ''),
                contentType: 'image/png',
              }),
            })
              .then(function (r) {
                return r.json();
              })
              .then(function (d) {
                afterCompositeUpload(d.url || compositePngDataUrl);
              })
              .catch(function () {
                afterCompositeUpload(compositePngDataUrl);
              });
          });
          return; // ← end batch branch; single-mode continues below
        }

        // ── Step 1: upload PNG + JSON (deferred from Step 2) ──────────────
        if (btnTextEl) btnTextEl.textContent = 'Uploading design\u2026';
        uploadPngAndJson(function () {
          // Refresh properties with uploaded URLs
          lineItemProperties['_preview_url'] =
            (canvasState && canvasState.previewUrl) || lineItemProperties['_preview_url'];
          if (canvasState && canvasState.stateUrl) lineItemProperties['_design_state_url'] = canvasState.stateUrl;

          // ── Step 2: SVG generation + upload, then cart ──────────────────
          var generator = window.ENM_SVG_GENERATOR;
          var endpoint = window.ENM_VERCEL_UPLOAD_ENDPOINT;

          if (!generator || !canvasState) {
            submitCart(lineItemProperties);
            return;
          }

          if (btnTextEl) btnTextEl.textContent = 'Generating design file\u2026';
          var svgFilename = 'files/' + (savedProductHandle || 'design').replace(/[^a-z0-9-]/gi, '-') + '-' + Date.now() + '.svg';

          generator
            .generateSvg(canvasState)
            .then(function (svgString) {
              if (btnTextEl) btnTextEl.textContent = 'Uploading\u2026';
              return generator.uploadToBlob(svgString, endpoint, svgFilename);
            })
            .then(function (svgUrl) {
              lineItemProperties['_svg_url'] = svgUrl;
              submitCart(lineItemProperties);
            })
            .catch(function (err) {
              console.warn('[ENM SVG] Failed:', err.message, err);
              if (btnTextEl) btnTextEl.textContent = _editMode ? 'Updating\u2026' : 'Adding to Cart\u2026';
              submitCart(lineItemProperties);
            });
        });
      });
    }

    // ── Init ─────────────────────────────────────────────
    // Back link: navigate to the product page (Step 2), not the legacy /pages route
    var backLink = document.getElementById('enm-back-link');
    if (backLink && savedProductHandle) {
      backLink.href = '/products/' + savedProductHandle;
    }

    document.getElementById('enm-error-banner').style.display = 'none';

    updateSummary();

    if (mergeMode) {
      // Batch mode: hide proof frame, show thumbnail grid
      var proofFrame = document.getElementById('enm-proof-frame');
      if (proofFrame) proofFrame.style.display = 'none';
      var mergeGrid = document.getElementById('enm-merge-grid');
      if (mergeGrid) mergeGrid.style.display = '';
      var proofLabel = document.getElementById('enm-proof-label');
      if (proofLabel) proofLabel.textContent = mergeSequential
        ? 'Sequential Batch \u2014 ' + mergeCount + ' Tags (showing 3 representative previews)'
        : 'Batch Proof \u2014 ' + mergeCount + ' Individual Plates';
      renderMergeGrid();

      // CTA button text
      var btnTextEl3 = document.getElementById('enm-cart-btn-text');
      if (btnTextEl3) btnTextEl3.textContent = 'Add ' + mergeCount + ' Plates to Cart';

      // Approve notice
      var approveNotice = document.getElementById('enm-approve-notice');
      if (approveNotice)
        approveNotice.innerHTML =
          'By clicking <strong>Add ' +
          mergeCount +
          ' Plates to Cart</strong>, you confirm all ' +
          mergeCount +
          ' proofs are correct. ' +
          '<strong>No changes can be made after production begins.</strong>';

      // Gallery subtitle
      var gallerySub = document.querySelector('.enm-s3__gallery-sub');
      if (gallerySub)
        gallerySub.textContent =
          'These are your ' +
          mergeCount +
          ' individual plate proofs. Click any thumbnail to view full size. Approve all before adding to cart.';
    } else {
      renderProof();
    }

    // Apply edit mode UI
    if (_editMode) {
      var editBannerEl = document.getElementById('enm-s3-edit-banner');
      if (editBannerEl) editBannerEl.style.display = '';
      var btnTextEl2 = document.getElementById('enm-cart-btn-text');
      if (btnTextEl2) btnTextEl2.textContent = 'Update Cart Item';
    }

    // Re-render once bwip-js CDN script finishes loading so real barcodes replace the placeholder
    window.addEventListener('load', function () {
      if (mergeMode) { renderMergeGrid(); } else { renderProof(); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enm-v2-customizer"]) return;
  try {
    
(function () {
  'use strict';

  function syncOptionsColumns() {
    var optionsBody = document.getElementById('enm-v2-options-body');
    if (!optionsBody) return;
    var count = optionsBody.querySelectorAll('.enm-v2__opt-group').length;
    optionsBody.classList.toggle('enm-v2__acc-body--two-cols', count >= 2);
  }

  // ── Accordion toggles — exclusive: one open at a time ────────────────────
  var allTriggers = Array.prototype.slice.call(document.querySelectorAll('.enm-v2__acc-trigger'));
  allTriggers.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      // Collapse all
      allTriggers.forEach(function (other) {
        var otherId = other.getAttribute('aria-controls');
        var otherBody = document.getElementById(otherId);
        if (otherBody) otherBody.style.display = 'none';
        other.setAttribute('aria-expanded', 'false');
      });
      // Open clicked one if it was closed
      if (!isOpen) {
        var bodyId = btn.getAttribute('aria-controls');
        var body = document.getElementById(bodyId);
        if (body) body.style.display = 'block';
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  syncOptionsColumns();
  var optionsBody = document.getElementById('enm-v2-options-body');
  if (optionsBody && window.MutationObserver) {
    var observer = new MutationObserver(syncOptionsColumns);
    observer.observe(optionsBody, { childList: true, subtree: true });
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enm-v2-industrial"]) return;
  try {
    
(function () {
  'use strict';

  function syncOptionsColumns() {
    var optionsBody = document.getElementById('enm-v2-options-body');
    if (!optionsBody) return;
    var count = optionsBody.querySelectorAll('.enm-v2__opt-group').length;
    optionsBody.classList.toggle('enm-v2__acc-body--two-cols', count >= 2);
  }

  // ── Accordion toggles — exclusive: one open at a time ────────────────────
  var allTriggers = Array.prototype.slice.call(document.querySelectorAll('.enm-v2__acc-trigger'));
  allTriggers.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      // Collapse all
      allTriggers.forEach(function (other) {
        var otherId = other.getAttribute('aria-controls');
        var otherBody = document.getElementById(otherId);
        if (otherBody) otherBody.style.display = 'none';
        other.setAttribute('aria-expanded', 'false');
      });
      // Open clicked one if it was closed
      if (!isOpen) {
        var bodyId = btn.getAttribute('aria-controls');
        var body = document.getElementById(bodyId);
        if (body) body.style.display = 'block';
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  syncOptionsColumns();
  var optionsBody = document.getElementById('enm-v2-options-body');
  if (optionsBody && window.MutationObserver) {
    var observer = new MutationObserver(syncOptionsColumns);
    observer.observe(optionsBody, { childList: true, subtree: true });
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
